"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactEventListener = _interopRequireDefault(require("react-event-listener"));

var _ownerDocument = _interopRequireDefault(require("../../utils/ownerDocument"));

var ClickAwayListener =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(ClickAwayListener, _React$Component);

  function ClickAwayListener() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, ClickAwayListener);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(ClickAwayListener)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "mounted", false);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "moved", false);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClickAway", function (event) {
      var node = _this.props.node,
          doc = (0, _ownerDocument["default"])(node),
          parentWindow = doc.defaultView; // Ignore events that have been `event.preventDefault()` marked.

      if (event.defaultPrevented) {
        return;
      } // IE 11 support, which trigger the handleClickAway even after the unbind


      if (!_this.mounted) {
        return;
      } // Do not act if user performed touchmove


      if (_this.moved) {
        _this.moved = false;
        return;
      } // The child might render null.


      if (!node || !(node instanceof parentWindow.HTMLElement)) {
        return;
      }

      if (doc.documentElement && doc.documentElement.contains(event.target) && !node.contains(event.target)) {
        _this.props.onClickAway(event);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleTouchMove", function () {
      _this.moved = true;
    });
    return _this;
  }

  (0, _createClass2["default"])(ClickAwayListener, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          mouseEvent = _this$props.mouseEvent,
          touchEvent = _this$props.touchEvent,
          node = _this$props.node,
          other = (0, _objectWithoutProperties2["default"])(_this$props, ["children", "mouseEvent", "touchEvent", "node"]),
          listenerProps = {};

      if (mouseEvent !== false) {
        listenerProps[mouseEvent] = this.handleClickAway;
      }

      if (touchEvent !== false) {
        listenerProps[touchEvent] = this.handleClickAway;
        listenerProps.onTouchMove = this.handleTouchMove;
      }

      return _react["default"].createElement(_react["default"].Fragment, null, children, node ? _react["default"].createElement(_reactEventListener["default"], (0, _extends2["default"])({
        target: (0, _ownerDocument["default"])(node)
      }, listenerProps, other)) : null);
    }
  }]);
  return ClickAwayListener;
}(_react["default"].Component);

(0, _defineProperty2["default"])(ClickAwayListener, "propTypes", {
  node: _propTypes["default"].any,

  /**
   * The wrapped element.
   */
  children: _propTypes["default"].element,

  /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   */
  mouseEvent: _propTypes["default"].oneOf(['onClick', 'onMouseDown', 'onMouseUp', false]),

  /**
   * Callback fired when a "click away" event is detected.
   */
  onClickAway: _propTypes["default"].func.isRequired,

  /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   */
  touchEvent: _propTypes["default"].oneOf(['onTouchStart', 'onTouchEnd', false])
});
(0, _defineProperty2["default"])(ClickAwayListener, "defaultProps", {
  mouseEvent: 'onMouseUp',
  touchEvent: 'onTouchEnd'
});
var _default = ClickAwayListener;
exports["default"] = _default;